import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AuthguardService } from "./services/authguard/authguard.service";

const routes: Routes = [
  {
    path: "",
    redirectTo: "onboarding",
    pathMatch: "full",
  },
  {
    path: "onboarding",
    loadChildren: () =>
      import("./pages/onboarding/onboarding.module").then(
        (m) => m.OnboardingPageModule
      ),
  },

  {
    path: "tabs-page",
    canActivate:[AuthguardService],
    loadChildren: () =>
      import("./pages/tabs-page/tabs-page.module").then(
        (m) => m.TabsPagePageModule
      ),
  },
  {
    path: "rootTabs",
    canActivate: [AuthguardService],
    loadChildren: () =>
      import("./shared/tabs/tabs.module").then((m) => m.TabsPageModule),
  },



  {
    path: "dashboard",
    canActivate:[AuthguardService],
    loadChildren: () =>
      import("./pages/dashboard/dashboard.module").then(
        (m) => m.DashboardPageModule
      ),
  },
  {
    path: 'camera-modal',
    loadChildren: () => import('./components/camera-modal/camera-modal.module').then( m => m.CameraModalPageModule)
  },


  // {
  //   path: "profilepage",
  //   loadChildren: () =>
  //     import("./pages/users/profilepage/profilepage.module").then(
  //       (m) => m.ProfilepagePageModule
  //     ),
  // },

  // {
  //   path: "pointledger",
  //   loadChildren: () =>
  //     import("./pages/users/pointledger/pointledger.module").then(
  //       (m) => m.PointledgerPageModule
  //     ),
  // },
  // {
  //   path: "order-summary",
  //   loadChildren: () =>
  //     import("./pages/order-summary/order-summary.module").then(
  //       (m) => m.OrderSummaryPageModule
  //     ),
  // },
  // {
  //   path: "common-succes-modal",
  //   loadChildren: () =>
  //     import("./pages/users/common-succes-modal/common-succes-modal.module").then(
  //       (m) => m.CommonSuccesModalPageModule
  //     ),
  // },

  // {
  //   path: "scan-earn",
  //   loadChildren: () =>
  //     import("./pages/scan-earn/scan-earn.module").then(
  //       (m) => m.ScanEarnPageModule
  //     ),
  // },
  // {
  //   path: "refer-earn",
  //   loadChildren: () =>
  //     import("./pages/refer-earn/refer-earn.module").then(
  //       (m) => m.ReferEarnPageModule
  //     ),
  // },
  // {
  //   path: "pan-verification",
  //   loadChildren: () =>
  //     import("./pages/onboarding/pan-verification/pan-verification.module").then(
  //       (m) => m.PanVerificationPageModule
  //     ),
  // },
  // {
  //   path: "id-proof-otp",
  //   loadChildren: () =>
  //     import("./pages/onboarding/id-proof-otp/id-proof-otp.module").then(
  //       (m) => m.IdProofOtpPageModule
  //     ),
  // },
  // {
  //   path: 'rewards',
  //   loadChildren: () => import('./pages/rewards/rewards.module').then( m => m.RewardsPageModule)
  // },
  // {
  //   path: 'lava-products',
  //   loadChildren: () => import('./pages/lava-products/lava-products.module').then( m => m.LavaProductsPageModule)
  // },
  // {
  //   path: 'menu',
  //   loadChildren: () => import('./pages/menu/menu.module').then( m => m.MenuPageModule)
  // },



];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
